import Swiper, { FreeMode } from "swiper"
import lottie from "lottie-web"

window.addEventListener('DOMContentLoaded', function(event){

    if(body.classList.contains('home')) {

        if(window.outerWidth > 991) {
            heroAnim()
        }

        homeSwiper()
        homeTabs()

    }

})

function heroAnim() {

    const container = document.querySelector('.fpHero__anim')

    //Clip-path
    const background = document.querySelector('.fpHero__background')

    //Scale
    const image = document.querySelector('.fpHero__image')

    //Translate
    const wrapper = document.querySelector('.fpHero__wrapper')

    const delay = 1000

    const myAnim = lottie.loadAnimation({
        container: container,
        renderer: (window.devicePixelRatio > 1) ? 'svg' : 'canvas',
        loop: false,
        autoplay: false,
        path: container.dataset.lottie
    })

    setTimeout(() => {

        image.classList.add('play')
        wrapper.classList.add('play')
        background.classList.add('play')

    }, delay)

    setTimeout(() => {

        myAnim.play()

    }, delay  + 150)

    setTimeout(() => {

        document.querySelector('.header__primary').classList.add('onHero')

    }, delay + 1150)

    
    setTimeout(() => {

        const tac = document.getElementById('tarteaucitronRoot')

        if(tac) {
        
            tac.classList.add('afterAnim')

        }

    }, delay + 3500)

}

function homeSwiper() {

    const swiper = new Swiper(".swiper", {
        modules: [FreeMode],
        loop: false,
        slidesPerView: 'auto',
        slidesOffsetBefore: 5,
        slidesOffsetAfter: 5,
        spaceBetween: 0,
        resistanceRatio: 0.6,
        speed: 500,
        touchAngle: 90,
        freeMode: true,
        init: (window.outerWidth < 768 ? true : false),
    })

    window.addEventListener('resize', () => {
        if(window.outerWidth < 768) {
            swiper.init()
        } else {
            swiper.disable()
        }
    })

}

function homeTabs() {

    const tabs = document.querySelector('.fpTabs')
    const btns = tabs.querySelectorAll('.fpTabs__menu__btn')
    const items = tabs.querySelectorAll('.fpTabs__item')

    const menu = tabs.querySelector('.fpTabs__menu')

    function fixHeight() {

        //Fixer la hauteur du menu sur le premier item
        menu.style.height = menu.getBoundingClientRect().height + 'px'

        //Fix pour transition premier item
        items[0].style.maxHeight = items[0].scrollHeight + "px"

    }

    const lazyload = () => {

        const targetNodes = document.querySelectorAll('img.fpTabs__item__image[data-lazy-src]')

        if(targetNodes.length) {

            const config = { attributes: true}
    
            targetNodes.forEach(targetNode => {
        
                const callback = mutationsList => {
        
                    mutationsList.forEach(mutation => {
        
                        if(mutation.type == 'attributes' && mutation.attributeName == 'data-ll-status') {
                            setTimeout(() => {
                                fixHeight()
                            }, 25)
                        }
                    })
        
                }
        
                const observer = new MutationObserver(callback)
                observer.observe(targetNode, config)
            })

        } else {

            setTimeout(() => {
                fixHeight()
            }, 25)

        }

    }

    lazyload()

    btns.forEach((btn) => {
        const key = btn.dataset.key
        btn.addEventListener('click', () => {
            if(window.innerWidth >= 975) {
                btns.forEach((btn) => {
                    if(btn.dataset.key != key) {
                        btn.classList.remove('active')
                    } else {
                        btn.classList.add('active')
                    }
                })
                items.forEach((item, itemKey) => {
                    if(itemKey != key) {
                            setTimeout(() => {
                                item.style.display = 'none'
                            }, 450)
                        item.classList.remove('active')
                    } else {
                        item.style.display = 'block'
                        setTimeout(() => {
                            item.classList.add('active')
                        }, 50)
                    }
                })
            } else {
                btn.classList.toggle('active')
                items.forEach((item, itemKey) => {
                    if(itemKey == key) {
                        if(btn.classList.contains('active')) {
                            item.style.maxHeight = item.scrollHeight + "px"
                        } else {
                            item.style.maxHeight = 0
                        }
                    }
                })
            }
        })
    })

}